(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-tab"] && !Shopify.designMode) return;
  try {
    
  const collectionTab = document.querySelectorAll(".collection-tab-button");
  const collectionTabPanel = document.querySelectorAll(".collection-tab-panel");

  let current = null;

  /* 🔹 Default first tab active */
  // if (collectionTab.length) {
  //   collectionTab[0].classList.add("active");
  // }

  /* 🔹 Click → scroll to tab panel */
  collectionTab.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (!targetId || !targetId.startsWith("#")) return;

      const targetSection = document.querySelector(targetId);
      if (!targetSection) return;

      e.preventDefault();

      // Update active immediately on click
      collectionTab.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const offset = 120; // adjust for sticky header
      const top =
        targetSection.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });

  /* 🔹 Scroll → update active tab */
  window.addEventListener("scroll", () => {
    collectionTabPanel.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (window.scrollY >= sectionTop - 130) {
        current = section.getAttribute("id");
      }
    });

    if (!current) return;

    collectionTab.forEach((tab) => {
      tab.classList.toggle(
        "active",
        tab.getAttribute("href") === `#${current}`
      );
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll(".tab-main");
  const panes = document.querySelectorAll(".product-tab-pane");

  let current = null;

  /* 🔹 Default first tab active */
  if (tabs.length) {
    tabs[0].classList.add("active");
  }

  /* 🔹 Click → scroll to section */
  tabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (!targetId || !targetId.startsWith("#")) return;

      const targetSection = document.querySelector(targetId);
      if (!targetSection) return;

      e.preventDefault();

      // Remove active from all
      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const offset = 120; // adjust for sticky header
      const top =
        targetSection.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });

  /* 🔹 Scroll → update active tab */
  window.addEventListener("scroll", () => {
    panes.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (window.scrollY >= sectionTop - 130) {
        current = section.getAttribute("id");
      }
    });

    if (!current) return;

    tabs.forEach((tab) => {
      tab.classList.toggle(
        "active",
        tab.getAttribute("href") === `#${current}`
      );
    });
  });


  /* accordion */
  const faqItems = document.querySelectorAll(".faq-item");

  function closeItem(item) {
    const button = item.querySelector(".faq-header");
    const body = item.querySelector(".faq-body");

    item.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    body.style.maxHeight = 0;
  }

  function openItem(item) {
    const button = item.querySelector(".faq-header");
    const body = item.querySelector(".faq-body");

    item.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    body.style.maxHeight = body.scrollHeight + "px";
  }

  // Initialize open/closed state
  faqItems.forEach((item) => {
    const body = item.querySelector(".faq-body");
    if (item.classList.contains("is-open")) {
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      body.style.maxHeight = 0;
    }
  });

  // Click behavior (only one open at a time)
  faqItems.forEach((item) => {
    const button = item.querySelector(".faq-header");

    button.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");

      faqItems.forEach((faq) => closeItem(faq));

      if (!isOpen) {
        openItem(item);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ronny-text-icons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#textIconsSplide', {
      type       : 'loop',
      drag: false,
      arrows     : false,
      pagination : false,
      focus      : 'center',
      autoWidth: true,
      autoScroll : {
        speed : 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      }
    }).mount(window.splide.Extensions);
  });

  } catch(e) { console.error(e); }
})();
})();
